<template>
  <div @keyup.13="submit">
    <mu-dialog
      title="新增转账审核"
      width="500"
      :open="open"
      @close="close"
      class="create-dialog"
    >
      <mu-form :model="form" label-position="left" label-width="100" ref="form">
        <mu-form-item prop="verifier" label="审核人">
          <mu-text-field v-model="form.verifier"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="verifyTime" label="审核时间">
          <mu-text-field v-model="form.verifyTime"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="isVerified" label="是否通过">
          <mu-text-field v-model="form.isVerified"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="remark" label="备注">
          <mu-text-field v-model="form.remark"></mu-text-field>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        verifier: '',
        verifyTime: '',
        isVerified: '',
        remark: ''
      }
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate().then((flag) => {
        if (flag) {
          backend(api.transferverify.create, this.form).then((result) => {
            if (result.statusCode === 200) {
              this.close()
              this.$emit('finish')
              this.form = {
                verifier: '',
                verifyTime: '',
                isVerified: '',
                remark: ''
              }
            }
          })
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    }
  }
}
</script>

<style lang="less" scoped>
.create-dialog {
}
</style>



// WEBPACK FOOTER //
// src/views/transferVerify/create.vue